import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";
import "../../styles/productsection.css";

const ProductSection = ({ title, viewAllLink, products = [] }) => {
  // Filter best selling products here
  const bestSelling = products.filter(
    (item) => item.best_selling == "true"
  );
  console.log(products);
  

  return (
    <>
      {/* Best Selling Section */}
      {/* {bestSelling.length > 0 && (
        <section className="product-section">
          <div className="section-header">
            <h2 className="section-title">
              <span>Best Selling Products</span>
            </h2>

            <Link to={viewAllLink} className="view-all-btn">
              View All →
            </Link>
          </div>

          <div className="plp-grid">
            {bestSelling.map((item) => (
              <BestSellingProducts key={item._id} product={item} />
            ))}
          </div>
        </section>
      )} */}

      {/* All Products Section */}
      <section className="product-section">
        <div className="section-header">
          <h2 className="section-title">
            <span>{title}</span>
          </h2>

          <Link to={viewAllLink} className="view-all-btn">
            View All →
          </Link>
        </div>

        <div className="plp-grid">
          {products.map((item) => (
            <ProductCard key={item._id} product={item} />
          ))}
        </div>

        <hr />
      </section>
    </>
  );
};

export default ProductSection;
